import React, { useEffect } from "react";
// import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import Section from "../Section";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";

const awardsData = [
  { imgUrl: "/images/home_1/awardfirst.png", href: "/products/product-2" },
  { imgUrl: "/images/home_1/awardsecond.png", href: "/products/product-3" },
  { imgUrl: "/images/home_1/awardthird.png", href: "/products/product-4" },
   { imgUrl: "/images/home_1/awardfirst.png", href: "/products/product-2" },
  { imgUrl: "/images/home_1/awardsecond.png", href: "/products/product-3" },
  { imgUrl: "/images/home_1/awardthird.png", href: "/products/product-4" },
   { imgUrl: "/images/home_1/awardfirst.png", href: "/products/product-2" },
  { imgUrl: "/images/home_1/awardsecond.png", href: "/products/product-3" },
  { imgUrl: "/images/home_1/awardthird.png", href: "/products/product-4" },
];

const OurAwards = () => {
  useEffect(() => {
    const fancyCssUrl = "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css";
    const fancyJsUrl = "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.umd.js";

    if (!document.querySelector(`link[href="${fancyCssUrl}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = fancyCssUrl;
      document.head.appendChild(link);
    }

    function initFancybox() {
      try {
        if (window.Fancybox && window.Fancybox.bind) {
          window.Fancybox.bind('[data-fancybox="awards"]', {});
        }
      } catch (e) {}
    }

    if (window.Fancybox) {
      initFancybox();
    } else if (!document.querySelector(`script[src="${fancyJsUrl}"]`)) {
      const s = document.createElement("script");
      s.src = fancyJsUrl;
      s.async = true;
      s.onload = initFancybox;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="Welcome to Celbion Healthcare"
        subTitle="Our Awards"
      />
      <Section topMd={80} bottomMd={120} bottomLg={90}>
        <div className="awards-page">
          <div className="container">
            <div className="section-heading text-center">
              <h2>Our Awards</h2>
              <p className="award-text">
                True success is built through consistent effort, shared
                determination, and collective vision. At Celbion Healthcare,
                our progress has been driven by a unified team that works
                together with passion and purpose, believing that growth has no
                limits.
              </p>
              <p className="award-text">
                From the very beginning, we have followed a distinctive approach
                focused on enhancing quality of life through reliable and
                science-driven pharmaceutical solutions. By embracing innovation
                and collaboration, we strive to develop effective answers to
                some of the most complex healthcare challenges.
              </p>
              <p className="award-text">
                In a relatively short period, we have reached significant
                milestones—achievements made possible by the dedication and
                commitment of every member of our team. Alongside growth, we
                remain deeply committed to our social responsibilities,
                contributing to the health of our nation by delivering medicines
                that meet the highest standards of quality and care.
              </p>
            </div>

            <div className="row">
              {awardsData && awardsData.length > 0 ? (
                awardsData.map((item, idx) => (
                  <div key={item.imgUrl || idx} className="col-lg-4 col-md-6 mb-4">
                    <div className="award-item cs_product_box">
                      <div className="award-image cs_product_img">
                        <a data-fancybox="awards" href={item.imgUrl} data-caption={item.title || ""}>
                          <img
                            src={item.imgUrl}
                            alt={item.title || `award-${idx}`}
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                          />
                        </a>
                      </div>
                      <div className="award-title" style={{ paddingTop: 8, textAlign: "center" }}>
                        {item.title || ""}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12">No awards found.</div>
              )}
            </div>
          </div>
        </div>
      </Section>
    </>
  );
};

export default OurAwards;
